import { capture } from '@tagadapay/analytics';

export function trackSetupCheckoutPreviewShown(properties: {
  funnelId?: string;
  checkoutUrl?: string;
  storeId?: string;
}): void {
  capture('setup_checkout_preview_shown', {
    funnel_id: properties.funnelId,
    checkout_url: properties.checkoutUrl,
    store_id: properties.storeId,
  });
}
